import gql from "graphql-tag";

export const generateReportScheduledServices = gql`
  query GenerateReportScheduledServices(
    $where: ScheduledExpertServiceWhereInput
    $markAsPaid: Boolean = false
  ) {
    reportScheduledExpertServices(
      orderBy: updatedAt_DESC
      where: $where
      markAsPaid: $markAsPaid
    ) {
      url
    }
  }
`;
